import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SelectOption } from '@vchasno/ui-kit';

interface SessionState {
  onboardingCompany: Nullable<SelectOption>;
}

const initialState: SessionState = {
  onboardingCompany: null,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setOnboardingCompany: (state, action: PayloadAction<SelectOption>) => {
      state.onboardingCompany = action.payload;
    },
  },
  selectors: {
    selectOnboardingCompany: (state) => state.onboardingCompany,
  },
});
